import colors from './colors';
import fontFamily from './fontFamily';
import palette from './palette';
import spacing from './spacing';
import breakpoints from './breakpoints';
import mainColors from './mainColors';

export {
  getNeutralColors,
  getOrangeColors,
  getVioletColors,
  getBlueColors,
  getlightBlue,
  getYellowColors,
  getRedColors,
  getGreenColors,
  getBrackgroundColors,
  getBorderColors,
  getBackgroundColors,
  getMainColor
} from './utils';

export default {
  colors,
  mainColors,
  fontFamily,
  palette,
  spacing,
  breakpoints
};
